import script from "./QueriesContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueriesContainer.vue?vue&type=script&lang=ts&setup=true"

import "./QueriesContainer.vue?vue&type=style&index=0&id=d1ee862a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1ee862a"]])

export default __exports__